module.exports = __webpack_public_path__ + "static/img/img-features-feature-5-accessibility_en.a5568ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-5-accessibility_en.png
// module id = fdwo
// module chunks = 18